// src/pages/Chat/PollModal.jsx
import React, { useState } from "react";
import { FiX, FiPlus, FiTrash2, FiBarChart2 } from "react-icons/fi";

export default function PollModal({ onClose, onCreate, initialData }) {
  const [question, setQuestion] = useState(initialData?.question || "");
  const [options, setOptions] = useState(initialData?.options || ["", ""]);

  const addOption = () => {
    if (options.length < 5) setOptions([...options, ""]);
  };

  const removeOption = (idx) => {
    if (options.length > 2) setOptions(options.filter((_, i) => i !== idx));
  };

  const updateOption = (idx, val) => {
    const next = [...options];
    next[idx] = val;
    setOptions(next);
  };

  const handleCreate = () => {
    const filteredOptions = options.filter(o => o.trim());
    if (!question.trim() || filteredOptions.length < 2) {
      alert("Please enter a question and at least 2 options.");
      return;
    }
    onCreate({
      question: question.trim(),
      options: filteredOptions
    });
  };

  return (
    <>
      <div className="fixed inset-0 z-[110] bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="fixed z-[111] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-sm">
        <div className="bg-slate-900 border border-white/10 rounded-2xl shadow-2xl overflow-hidden flex flex-col p-5 gap-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <FiBarChart2 className="text-amber-500" size={18} />
              <span className="text-sm font-semibold text-slate-100">{initialData ? "Edit Poll" : "Create Poll"}</span>
            </div>
            <button onClick={onClose} className="p-1 text-slate-500 hover:text-slate-300">
              <FiX size={18} />
            </button>
          </div>

          <div className="space-y-3">
            <div>
              <label className="text-[10px] uppercase font-bold text-slate-500 mb-1 block">Question</label>
              <textarea
                autoFocus
                placeholder="Ask something..."
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                className="w-full px-3 py-2 rounded-xl text-xs bg-white/5 border border-white/10 text-slate-200 outline-none focus:border-amber-500/50 transition-all min-h-[60px] resize-none"
              />
            </div>

            <div>
              <label className="text-[10px] uppercase font-bold text-slate-500 mb-1 block">Options</label>
              <div className="space-y-2">
                {options.map((opt, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <input
                      placeholder={`Option ${i + 1}`}
                      value={opt}
                      onChange={(e) => updateOption(i, e.target.value)}
                      className="flex-1 px-3 py-2 rounded-lg text-xs bg-white/5 border border-white/10 text-slate-200 outline-none focus:border-amber-500/50 transition-all"
                    />
                    {options.length > 2 && (
                      <button onClick={() => removeOption(i)} className="text-slate-600 hover:text-red-400">
                        <FiTrash2 size={14} />
                      </button>
                    )}
                  </div>
                ))}
              </div>
              {options.length < 5 && (
                <button
                  onClick={addOption}
                  className="mt-2 text-[10px] font-bold text-amber-400 hover:text-amber-300 flex items-center gap-1 transition-colors"
                >
                  <FiPlus size={12} /> Add Option
                </button>
              )}
            </div>
          </div>

          <button
            onClick={handleCreate}
            className="w-full py-2.5 rounded-xl bg-amber-600 text-white text-xs font-bold hover:bg-amber-500 transition-all shadow-lg shadow-amber-600/20 mt-2"
          >
            {initialData ? "Save Changes" : "Send Poll"}
          </button>
        </div>
      </div>
    </>
  );
}
